let _spinnerCounter = 0;

const Spinner = function () {
  _spinnerCounter++;
  let element = document.getElementById('spinner-backdrop');
  if (element) return;
  element = document.createElement('div');
  element.id = 'spinner-backdrop';
  element.className = 'spinner-backdrop d-flex justify-content-center align-items-center';

  let spinner = document.createElement('div');
  spinner.className = 'spinner-border';
  spinner.style = 'width: 3rem; height: 3rem;';
  element.appendChild(spinner);
  document.body.appendChild(element);
};

Spinner.prototype = {
  stop: function () {
    _spinnerCounter--;
    if (_spinnerCounter < 0) _spinnerCounter = 0;
    let element = document.getElementById('spinner-backdrop');
    if (_spinnerCounter == 0 && element) {
      element.remove();
    }
  }
};

export default Spinner;
